import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import { hotkey } from '#utilities/js/hotkey/hotkey.js'

const handler = object(null, {
  task (
    element,
    event
  ) {
    preventDefault(event)
    globals.ea_elt_display_id('id_translate', true, true)
  }
})

export default (
  element
) => {
  hotkey(element, handler)
}
